import Events from '@pixelunion/events';
import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticFooter {
  constructor(section) {
    this.el = section.el;
    this.mailingListEl = this.el.querySelector('.mailing-list');
    this.upperFooterEl = this.el.querySelector('.upper-footer');
    this.events = new Events();

    const countryDisclosureEls = section.el.querySelectorAll('[data-disclosure-country]');
    const localeDisclosureEls = section.el.querySelectorAll('[data-disclosure-locale]');
    this.disclosures = [];

    if (countryDisclosureEls.length > 0) {
      countryDisclosureEls.forEach(disclosureEl => {
        this.disclosures.push(new Disclosure(disclosureEl));
      });
    }

    if (localeDisclosureEls.length > 0) {
      localeDisclosureEls.forEach(disclosureEl => {
        this.disclosures.push(new Disclosure(disclosureEl));
      });
    }

    this.events.register(window, 'resize', () => {
      // If the resize was triggered by an Android device's keyboard opening, return
      if (document.activeElement.getAttribute('type') === 'email') return;
      if (!this.mailingListEl) return;

      if ((window.innerWidth <= 1080) && (window.innerWidth !== this.width)) {
        this.upperFooterEl.insertBefore(this.mailingListEl, this.upperFooterEl.firstChild);
      } else if (window.innerWidth !== this.width) {
        this.upperFooterEl.appendChild(this.mailingListEl);
      }
    });
  }

  onSectionUnload() {
    this.events.unregisterAll();

    this.disclosures.forEach(disclosure => disclosure.unload());
  }
}
